import { useEffect, useRef, useState } from "react";

const TRIGGER = 80; // px the finger must travel down to reload
const MAX_PULL = 120;

// True when the touch started inside something that is scrolled away from its top,
// so the pull belongs to that scroll and not to a reload.
const insideScrolledArea = (node) => {
  for (let el = node; el && el !== document.body; el = el.parentElement) {
    if (el.scrollTop > 1) return true;
  }
  return window.scrollY > 1;
};

/** Pull the screen down from the top to reload it. */
const PullToRefresh = () => {
  const [pull, setPull] = useState(0);
  const [reloading, setReloading] = useState(false);
  const startY = useRef(null);
  const pullRef = useRef(0);

  useEffect(() => {
    const onStart = (e) => {
      const tag = e.target?.tagName;
      if (e.touches.length !== 1 || tag === "INPUT" || tag === "TEXTAREA" || insideScrolledArea(e.target)) {
        startY.current = null;
        return;
      }
      startY.current = e.touches[0].clientY;
    };
    const onMove = (e) => {
      if (startY.current == null) return;
      const delta = e.touches[0].clientY - startY.current;
      if (delta <= 0) {
        pullRef.current = 0;
        setPull(0);
        return;
      }
      pullRef.current = Math.min(MAX_PULL, delta * 0.5);
      setPull(pullRef.current);
    };
    const onEnd = () => {
      if (startY.current == null) return;
      startY.current = null;
      if (pullRef.current >= TRIGGER * 0.5) {
        setReloading(true);
        window.location.reload();
      } else {
        pullRef.current = 0;
        setPull(0);
      }
    };
    document.addEventListener("touchstart", onStart, { passive: true });
    document.addEventListener("touchmove", onMove, { passive: true });
    document.addEventListener("touchend", onEnd);
    document.addEventListener("touchcancel", onEnd);
    return () => {
      document.removeEventListener("touchstart", onStart);
      document.removeEventListener("touchmove", onMove);
      document.removeEventListener("touchend", onEnd);
      document.removeEventListener("touchcancel", onEnd);
    };
  }, []);

  if (pull <= 0 && !reloading) return null;
  const size = reloading ? 40 : Math.max(16, (pull / MAX_PULL) * 40);
  return (
    <div
      className="fixed left-0 right-0 top-0 flex justify-center pointer-events-none"
      // Above the menu header, which is pinned at z-index 1000.
      style={{ zIndex: 2000, transform: `translateY(${reloading ? 24 : pull * 0.6}px)` }}
      aria-hidden="true"
    >
      <span
        className={`rounded-full border-4 border-primary-50 border-t-primary bg-background shadow-toast ${reloading ? "animate-spin" : ""}`}
        style={{ width: size, height: size, transform: reloading ? undefined : `rotate(${pull * 3}deg)` }}
      />
    </div>
  );
};

export default PullToRefresh;
